import { api } from './client';

export interface Tag {
  id: number;
  tag_name: string;
  color: string;
  usage_count?: number;
  created_at: string;
}

export const tagsApi = {
  /** List all tags with usage count */
  list: () => api.get<Tag[]>('/tags'),

  /** Create a new tag */
  create: (tag_name: string, color?: string) =>
    api.post<Tag>('/tags', { tag_name, color }),

  /** Add tag to task (creates tag if not exists) */
  link: (task_id: string, tag_name: string, color?: string) =>
    api.post<{ task_id: string; tag_id: number; tag_name: string }>('/tags/link', { task_id, tag_name, color }),

  /** Remove tag from task */
  unlink: (task_id: string, tag_id: number) =>
    api.delete('/tags/link', { task_id, tag_id } as any),

  /** Get tags for a task */
  forTask: (task_id: string) => api.get<Tag[]>(`/tags/task/${task_id}`),
};
